import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'O que é sugar dating?',
    answer: 'Sugar dating é um modelo de relacionamento onde Sugar Daddies e Sugar Mommies oferecem suporte financeiro e experiências, enquanto Sugar Babies oferecem companhia e atenção. No Interlaced, garantimos que ambos os lados sejam claros sobre expectativas desde o início.',
  },
  {
    question: 'O que torna o Interlaced diferente de outros apps de sugar?',
    answer: 'Verificação rigorosa de perfis, foco em brasileiros, e ambiente que prioriza discrição. Aqui, Sugar Babies, Daddies e Mommies se conectam com transparência.',
  },
  {
    question: 'Como funciona a verificação de perfis?',
    answer: 'Processo que inclui verificação de identidade por selfie e e-mail. Garantimos que cada membro seja autêntico.',
  },
  {
    question: 'Meus dados estão seguros?',
    answer: 'Seu perfil nunca aparece no Google. Usamos criptografia e nunca compartilhamos suas informações com terceiros.',
  },
  {
    question: 'Posso usar gratuitamente?',
    answer: 'Sim! Oferecemos um plano gratuito com funcionalidades essenciais. Planos premium desbloqueiam recursos avançados.',
  },
  {
    question: 'Como cancelo minha conta?',
    answer: 'Você tem controle total. Pode desativar ou deletar sua conta a qualquer momento nas configurações.',
  },
];

const FAQSection = () => {
  return (
    <section id="faq" className="relative py-20 px-4 bg-black">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-luxury-pink via-luxury-mediumPink to-luxury-lightPurple bg-clip-text text-transparent">
            Perguntas Frequentes
          </h2>
          <p className="text-white/60 text-lg">
            Tudo que você precisa saber sobre o Interlaced
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-6 hover:border-luxury-pink/30 transition-colors duration-300"
              >
                <AccordionTrigger className="text-left text-white hover:text-luxury-pink transition-colors">
                  <span className="font-semibold">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-white/70 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
